import { useState } from 'react';

export function useArrayState({ initialItems = [], initialItem = null, selectFirstItem = true } = {}) {
  const [items, setItems] = useState(initialItems);
  const [selectedItem, setSelectedItem] = useState(
    (selectFirstItem && initialItems.length > 0 && initialItems[0]) || initialItem,
  );

  const updateItems = (items = []) => {
    setItems(items);
    if (selectFirstItem && items.length > 0) setSelectedItem(items[0]);
    else setSelectedItem(null);
  };

  return [items, updateItems, selectedItem, setSelectedItem];
}

export function useArrayStateObject({ initialItems = [], initialSelected = null } = {}) {
  const [items, setItems] = useState(initialItems);
  const [selected, setSelected] = useState(initialSelected ?? (initialItems.length > 0 ? initialItems[0] : null));

  const updateItems = (newItems) => {
    setItems(newItems);
    setSelected(newItems.length > 0 ? newItems[0] : null);
  };

  return {
    items,
    setItems: updateItems,
    selected,
    setSelected,
  };
}
